export const DEFAULT_API_BASE_URL = 'http://localhost:8080'
export const API_V1_PREFIX = '/api/v1'

// Log environment variables on module load
console.log('🔧 Environment Variables:', {
	VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
	defaultFallback: DEFAULT_API_BASE_URL,
	resolvedApiUrl: import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL
})

export const getApiBaseUrl = () => import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL 